import moment from 'moment/moment';

import ApiClient from '@lib/apiClient';

export const sourceType = {
	Instagram: 'INSTAGRAM',
	Brand: 'BRAND'
};

export function capitalizeFirstLetter(str) {
	if (!str) return '';

	return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function getMultiplyWith(length) {
	if (length > 90) return 6;
	else if (length >= 80 && length < 90) return 5;
	else if (length >= 70 && length < 80) return 4.5;
	else if (length >= 60 && length < 70) return 4;
	else if (length >= 50 && length < 60) return 3.5;
	else if (length > 40 && length < 50) return 3;
	else return 1;
}

export const mapSubCategory = (subItems) => {
	return subItems?.map((subItem) => ({
		id: subItem.id,
		name: subItem.name,
		count: subItem.count
	}));
};

export const mapBrandTypeSubCategory = (subItems) => {
	return subItems?.map((subItem) => ({
		id: subItem.typeConstant,
		name: subItem.typeName,
		count: subItem.totalCount,
		subCategory: [
			{
				name: 'All',
				id: 'ALL',
				count: subItem?.totalCount
			},
			...mapBrandSubCategory(subItem?.brands)
		]
	}));
};

export const mapBrandSubCategory = (subItems) => {
	return subItems?.map((subItem) => ({
		id: subItem.brandCode,
		name: subItem.brandName,
		count: subItem.count
	}));
};

export const mapCategoryList = (categories) => {
	return categories?.map((item, index) => ({
		id: `${index}_${item.parentCatergory}`,
		name: item.parentCatergory,
		count: item.count,
		subCategory: [
			{
				name: 'All',
				id: 'ALL',
				count: item?.count
			},
			...mapSubCategory(item?.categoryEntityCountList)
		]
	}));
};

export const mapBrandTypeList = (brands) => {
	return brands?.map((item, index) => ({
		id: `${index}_${item.operationalUnitName}`,
		name: item.operationalUnitName,
		count: item.totalCount,
		subCategory: [...mapBrandTypeSubCategory(item.brandTypeCountDTOS)]
	}));
};

export const getSearchValueForSimilarProducts = (singleProduct) => {
	if (!singleProduct) return null;

	const fields = [
		singleProduct.keyComposition,
		singleProduct.market,
		singleProduct.graphicsType,
		singleProduct.graphicsContent,
		singleProduct.fiberList?.join(' '),
		singleProduct.fabricTypeList?.join(''),
		singleProduct.themes?.join(''),
		singleProduct.color
	];

	const search = fields.filter(Boolean).join(' ').trim();
	return search || null;
};

export const trackMixPanelStyleEvent = (response, entityType, eventName) => {
	try {
		let reqBody = {
			entityType: entityType,
			name: response.name,
			market: response.market,
			fabricType: response.fabricTypeList,
			imageUrl: response.imageUrl,
			category: response.category
		};
		if (entityType === 'BRAND') {
			reqBody.brandName = response.brandName;
		}
		if (entityType === 'INSTAGRAM') {
			reqBody.userName = response.userName;
		}
		ApiClient.POST('mixpanelAddEvent', reqBody, eventName);
	} catch {}
};

export const getDateAgo = (date) => {
	if (!date) return '';
	return moment(date, 'YYYY-MM-DD').fromNow();
};
